import { Injectable } from '@angular/core';
import { Cacheable } from 'ngx-cacheable';
import { Observable, from, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { BcRestApi } from 'common/api/rest-api';
import { LogService } from 'common/logger/log.service';
import { LoggerService } from 'common/logger/logger.service';

@Injectable({
  providedIn: 'root'
})
export class CacheHelperService {
  private _logger: LoggerService;
  constructor(private _bcRestApi: BcRestApi,
              _logService: LogService) {
    this._logger = _logService.getLoggerInstance(CacheHelperService.name);
  }

  @Cacheable()
  public getCachedDepartmentName(departmentId: string): Observable<string> {
    if (!departmentId) {
      return of('');
    }
    return from(this._bcRestApi.getDepartment(departmentId)).pipe(
      map<{ name: string }, string>(department => department.name || ''),
      catchError((error: any) => {
        this._logger.logError('Retrieving department: {} failed. Error: {}', [departmentId, error]);
        return of('');
      })
    );
  }

  @Cacheable()
  public getCachedWebsiteName(websiteDefId: string): Observable<string> {
    if (!websiteDefId) {
      return of('');
    }
    return from(this._bcRestApi.getWebsiteDef(websiteDefId)).pipe(
      map<{ name: string }, string>(websiteDef => websiteDef.name || ''),
      catchError((error: any) => {
        this._logger.logError('Retrieving website: {} failed. Error: {}', [websiteDefId, error]);
        return of('');
      })
    );
  }

  @Cacheable()
  public getCachedFolderName(folderId: string): Observable<string> {
    if (!folderId) {
      return of('');
    }
    return from(this._bcRestApi.getFolder(folderId)).pipe(
      map<{ name: string }, string>(folder => folder.name || ''),
      catchError((error: any) => {
        this._logger.logError('Retrieving folder: {} failed. Error: {}', [folderId, error]);
        return of('');
      })
    );
  }
}
